import { BaseService } from '../../infra/base.service'
import type { CitiesRepository } from './cities.repository'
import type { CityEntity } from './city.entity'

export class CitiesService extends BaseService<CityEntity> {
    constructor(private rep: CitiesRepository) {
        super(rep)
    }
}
